
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-device-configuration-tutorial',
  templateUrl: './device-configuration-tutorial.component.html',
  styleUrls: ['./device-configuration-tutorial.component.scss']
})
export class DeviceConfigurationTutorialComponent implements OnInit {
   mantradriver="https://download.mantratecapp.com/forms/downloadfiles";
   mantraInstallationGuide=" https://images.vartulz.com/mantramfs.pdf";

   morphodriver="http://rdserviceonline.com/";
   morphoInstallationGuide="https://images.vartulz.com/morpho.pdf";

   startekdriver="https://www.acpl.in.net/RdService.html";
   startekInstallationGuide="https://images.vartulz.com/startek.pdf";

   secugendriver="https://secugen.com/drivers/";
   secugenInstallationGuide="https://images.vartulz.com/secugen.pdf";

   
  constructor() { }

  ngOnInit(): void {
  }
  driver(service){
    if(service == 6){
      window.open(this.mantradriver);

    }else if(service == 1){
      window.open(this.morphodriver);

    }else if(service == 3){
     window.open(this.startekdriver);
      
    }else if(service == 8){
     window.open(this.mantradriver);
      
    }else if(service==5){
      window.open(this.secugendriver);

    }

  }
  installationGuide(service){
    if(service == 6){
      window.open(this.mantraInstallationGuide);

    }else if(service == 1){
      window.open(this.morphoInstallationGuide);

    }else if(service == 3){
     window.open(this.startekInstallationGuide);
      
    }else if(service == 8){
     window.open(this.mantraInstallationGuide);
      
    }else if(service == 5){
      window.open(this.secugenInstallationGuide)
    }


  }
}
